module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Bold.83b8ceaf.woff2";